import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionActions from '@mui/material/AccordionActions';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const AccordionWidget = ({ title, content, actions, defaultExpanded }) => {
  return (
    <Accordion defaultExpanded={defaultExpanded}  sx={{
        backgroundColor: '#eee', 
      }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
      >
        <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
      {actions && (
        <AccordionActions>
          {actions.map((action, index) => (
            <Button key={index} onClick={action.onClick}>
              {action.label}
            </Button>
          ))}
        </AccordionActions>
      )}
    </Accordion>
  );
};

AccordionWidget.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ),
  defaultExpanded: PropTypes.bool,
};

AccordionWidget.defaultProps = {
  actions: null,
  defaultExpanded: false,
};

export default AccordionWidget;
